import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./msalConfig.ts";
import  AppInsightsProvider  from '@context/AppInsightsProvider.tsx';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <MsalProvider instance={msalInstance}>
      <AppInsightsProvider>
        <App />
      </AppInsightsProvider>
    </MsalProvider>
  </StrictMode>,
)
